import React from 'react';

import styled from '@emotion/styled';

// import KycRequired from '../../../components/Cards/KycRequired';
import PageLayout from '../../../components/Layout/PageLayout';
// import { Modal } from '../../../components/Modal/Modal';
import Page from '../../../components/Page/Page';
import StatsCard from './StatsCard';
import TripLogTables from './TripLogTables';

const TripLog = () => {
  // const [showKycRequiredModal, setShowKycRequiredModal] = useState(false);

  // const successActionFn = () => {
  //   setShowKycRequiredModal(false);
  // };

  return (
    <Page title='Logirate | Trip Log'>
      <PageLayout>
        <Container>
          <Header>Log List</Header>
          <StatsCard />
          <TripLogTables />

          {/* <Modal
            showModal={showKycRequiredModal}
            setShowModal={setShowKycRequiredModal}
          >
            <KycRequired
              successActionFn={successActionFn}
              message='You need to complete your KYC to create a trip log'
            />
          </Modal> */}
        </Container>
      </PageLayout>
    </Page>
  );
};

export default TripLog;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 22px;
  line-height: 22px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;
